import GravityAdapter from 'district-ui-client/adapters/gravity'

export default class PartnerContactDetailAdapter extends GravityAdapter {}
